import Order, { BankTransferOrder, OrderStatus } from "ts/api/order";
import { PaymentMethodType } from "ts/api/paymentMethod";
import getInvoices, {
  getInvoicesOrganiserRevenue,
} from "tools/order/getInvoices";
import groupBy from "lodash.groupby";
import { OrderReviewStatus, OrderReviewType } from "ts/api/orderReview";
import { mapOrderProduct } from "../../mapOrderProduct";
import { ComposeBankTransferOrderParams } from "../types";

const composeBankTransferOrder = async ({
  paymentType,
  products,
  standId,
  exhibitorId,
  billingDetails,
  totalAmount,
  organiser,
  show,
  transferredPaymentDescription,
  poNumbers,
  createdAt,
  isRequiredApproval,
  id,
  orderGroupId,
  exhibitorPairId,
  billingMetadata,
  isQuick,
  allowBankTransfer,
}: ComposeBankTransferOrderParams): Promise<BankTransferOrder> => {
  const orderBase: Omit<
    BankTransferOrder,
    "paymentDetails" | "products" | "invoices" | "organiserRevenue"
  > = {
    paymentType,
    exhibitorId,
    standId,
    billingDetails,
    createdAt,
    id,
    orderGroupId,
    ...(isQuick && { allowBankTransfer: !!allowBankTransfer }),
  };
  const productsBySupplier = Object.values(groupBy(products, "owner.id"));
  const invoices = await getInvoices({
    organiser,
    show,
    poNumbers,
    transferredPaymentDescription,
    orderId: id,
    fullProducts: productsBySupplier,
    billingMetadata,
  });
  const organiserRevenue = getInvoicesOrganiserRevenue(invoices);

  // eslint-disable-next-line @typescript-eslint/ban-types
  const review: Order["review"] | {} = isRequiredApproval
    ? {
        review: {
          type: OrderReviewType.any,
          status: OrderReviewStatus.waitingForApproval,
        },
      }
    : {};

  const order: BankTransferOrder = {
    ...orderBase,
    exhibitorPairId,
    invoices,
    organiserRevenue,
    paymentDetails: {
      amount: totalAmount,
      status: isRequiredApproval
        ? OrderStatus.reviewProcess
        : OrderStatus.processing,
    },
    ...review,
    products: products.map((product) =>
      mapOrderProduct(product, PaymentMethodType.bankTransfer)
    ),
  };
  return order;
};

export default composeBankTransferOrder;
